<template>
    <EmptyLayout v-if="enabled">
      <div class="d-flex flex-column">
        <div style="position: relative">
          <img src="@/assets/wizard/consumer-image-intro-page.png" style="width: 100%">
          <div class="overlay">
            Pros Recommended by Your Neighbors and Local Hardware Stores
          </div>
        </div>

        <v-card class="mx-2 mt-1 pa-2">
          <v-card-text class="black--text" style="font-size: 20px;">
            <strong>How it works</strong>
            <ul style="font-size: 16px;">
              <li class="mt-4">Select the project type, whether it's plumbing, electrical, or home upgrades.</li>
              <li class="mt-4">Get responses only from contractors who specialize in your requested service.</li>
              <li class="mt-4">Your info is shared with a maximum of four local contractors.</li>
            </ul>

            <div class="my-4 grey--text text--darken-1" style="font-size: 12px; line-height: 1.2;">
              Only homeowners or local businesses can add pros to our network.  Check out our
              Nextdoor profile to learn more.
            </div>

            <div style="width=100%" class="d-flex justify-center">
              <v-btn color="primary" @click="tryClick">Try it Now</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </EmptyLayout>

    <EmptyLayout v-else>
      <div 
        class="d-flex flex-column justify-center text-center align-center white"
        style="height: 100%"
      >
        <v-icon size="80px" color="yellow darken-2">mdi-alert-circle-outline</v-icon>
        <div class="mt-2 font-weight-bold">Oops! Something went wrong</div>
        <div class="mx-12 mt-4">
          This feature is not setup.  Please contact {{ account_name }}
          so they can make a referral for you.
        </div>
      </div>
    </EmptyLayout>
</template>

<script>
import { EmptyLayout } from '@/layouts'

import { mapActions } from 'vuex'

export default {
  name: 'QRView',

  components: { EmptyLayout },

  data: () => ({
    loading: false,
    enabled: true,
    account_name: '',
  }),

  methods: {
    ...mapActions('qr', ['isEnabled']),
    
    tryClick() {
      this.$router.replace({ name: 'qr/wizard/category'})
    }
  },


  async created() {
    this.loading = true
    
    const result = await this.isEnabled()
    if (!result.ok) {
      this.enabled = false
      this.account_name = result.account_name || 'the business that directed you here'
    }

    this.loading = false
  },
}
</script>

<style scoped>
  div.overlay {
    color: white;
    position: absolute;
    top: 50%;
    left: 0%;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.20;
    transform: translate(20%, -55%);
    text-align: center;
    width: 40%;
  }
</style>